import { map } from 'lodash';

import * as ActionTypes from '../components/actions/types';

const initialState = [];

function cmsEventInvoiceReducer(state = initialState, action) {
  switch (action.type) {
    case ActionTypes.FETCH_CMS_EVENT_INVOICES:
      return action.payload;
    case ActionTypes.REFUND_STRIPE_TICKET:
      return map(
        state,
        invoice => (invoice.invoiceNumber === action.payload
          ? { ...invoice, refunded: true }
          : invoice)
      );
    default:
      return state;
  }
}

export default cmsEventInvoiceReducer;



// WEBPACK FOOTER //
// ./src/reducers/cmsEventInvoices.js